export let VideoUrlType = /*#__PURE__*/function (VideoUrlType) {
  VideoUrlType["TRAILER"] = "TRAILER";
  VideoUrlType["CLIP"] = "CLIP";
  VideoUrlType["CONTENT"] = "CONTENT";
  VideoUrlType["AUTOGENERATED_TRAILER"] = "AUTOGENERATED_TRAILER";
  return VideoUrlType;
}({});
//# sourceMappingURL=video-url-type.js.map